import React, { useState } from "react";
import CustomButton from "../../../../components/CustomButton";
import { Modal, Button } from "react-bootstrap";

const Support = () => {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <div>
      <h6 className="bolder-text">Help</h6>
      <p className="small-text co-darkgray mt-3">
        We can provide you with the help you need by either sending us a ticket
        or reading through our FAQs.
      </p>

      <CustomButton
        leftALign
        additionalClass="my-3"
        text="Send Us A Ticket"
        backgroundColor="#3A6ED4"
        color="#fff"
        handleClick={handleShow}
      />

      <a href="/help" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
        <CustomButton
          leftALign
          additionalClass="my-3"
          text="Read Our FAQs"
          backgroundColor="#3A6ED4"
          color="#fff"
        />
      </a>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "15px", fontWeight: "600" }}>
            Send a Mail
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <a
            style={{ color: "#3A6ED4" }}
            href="mailto:tech-support@workbrook.com"
          >
            tech-support@workbrook.com
          </a>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Support;